import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, ImageOff } from 'lucide-react';
import AppThumbnail from './AppThumbnail';

/** Bộ ảnh của ứng dụng ở trang giới thiệu: ảnh lớn + dải thumbnail bên dưới. */
const AppGallery = ({ app }) => {
    const [index, setIndex] = useState(0);
    const images = app.images?.length ? app.images : app.thumbnail ? [app.thumbnail] : [];

    if (!images.length) {
        return (
            <div className="aspect-[16/10] rounded-2xl overflow-hidden border border-white/40 dark:border-white/[0.08] relative">
                <AppThumbnail app={app} />
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 text-xs text-slate-400 dark:text-slate-500">
                    <ImageOff className="w-3.5 h-3.5" />
                    Chưa có ảnh minh hoạ
                </div>
            </div>
        );
    }

    const go = (step) => setIndex((prev) => (prev + step + images.length) % images.length);

    return (
        <div className="space-y-3">
            <div className="relative group aspect-[16/10] rounded-2xl overflow-hidden bg-slate-100 dark:bg-slate-900 border border-white/40 dark:border-white/[0.08] shadow-lg shadow-slate-900/5 dark:shadow-black/30">
                {images.map((src, i) => (
                    <img
                        key={src + i}
                        src={src}
                        alt={`${app.title} — ảnh ${i + 1}`}
                        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                            i === index ? 'opacity-100' : 'opacity-0'
                        }`}
                    />
                ))}

                {images.length > 1 && (
                    <>
                        <button
                            onClick={() => go(-1)}
                            aria-label="Ảnh trước"
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm text-slate-700 dark:text-slate-200 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
                        >
                            <ChevronLeft className="w-5 h-5" />
                        </button>
                        <button
                            onClick={() => go(1)}
                            aria-label="Ảnh sau"
                            className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm text-slate-700 dark:text-slate-200 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
                        >
                            <ChevronRight className="w-5 h-5" />
                        </button>
                        <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs font-medium">
                            {index + 1} / {images.length}
                        </div>
                    </>
                )}
            </div>

            {images.length > 1 && (
                <div className="flex gap-3 overflow-x-auto pb-1">
                    {images.map((src, i) => (
                        <button
                            key={src + i}
                            onClick={() => setIndex(i)}
                            aria-label={`Xem ảnh ${i + 1}`}
                            className={`relative shrink-0 w-24 h-16 rounded-lg overflow-hidden border-2 transition-all ${
                                i === index
                                    ? 'border-primary-600'
                                    : 'border-transparent opacity-60 hover:opacity-100'
                            }`}
                        >
                            <img src={src} alt="" className="w-full h-full object-cover" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AppGallery;
